import * as React from 'react'
import {Box} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";


export default function dispersionColumn() {
    return {
        name: 'numDiscount', label: 'Price dispersion\nvs RRSP',
        options: {
			setCellHeaderProps: () => ({ sx: {
				whiteSpace: 'pre-wrap',
			}}),
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
				{value ? formatPercentage(value) : '-'}
			</Box>
        }
    }
}